<!-- Use preprocessors via the lang attribute! e.g. <template lang="pug"> -->
<template>
  <div class="custom-main" v-if="surveys">
    <div cols="12" md="6" align-self="start" class="mx-4 pb-16">
      <!-- //VOTE  -->
      <v-col cols="12" class="px-0 py-0">
        <h4 class="text-h6 py-3">Annual Survey</h4>
        <v-alert
          dense
          text
          type="success"
          class="body-2"
          v-if="getFeedback.dosurvey"
          >Terima kasih, anda sudah berpartisipasi dalam pengisian survey saat
          ini</v-alert
        >
        <div v-else>
          <v-expansion-panels v-if="panelsAcc" v-model="panelsAcc" multiple>
            <v-expansion-panel v-for="(sur, index) in surveys" :key="index">
              <v-expansion-panel-header class="font-weight-bold">{{
                sur.question
              }}</v-expansion-panel-header>
              <v-expansion-panel-content v-if="sliders">
                <v-col cols="12 pt-5">
                  <v-slider
                    :disabled="getFeedback.dosurvey"
                    hide-details="auto"
                    v-model="sliders[index]"
                    :thumb-size="24"
                    thumb-label="always"
                    step="10"
                  >
                    <template v-slot:thumb-label="{ value }">
                      {{
                        satisfactionEmojis[Math.min(Math.floor(value / 10), 9)]
                      }}
                    </template>
                  </v-slider>
                </v-col>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-btn
            :disabled="getFeedback.dosurvey"
            color="btnPrimary"
            @click="sendMsg()"
            block
            class="py-6 mb-10 white--text mt-2"
          >
            Send
          </v-btn>
        </div>
      </v-col>
      <!-- END VOTE  -->

      <v-col cols="12" class="px-0 py-0">
        <div class="text-h6body-2 font-weight-bold black--text py-3">
          <h4 class="text-h6">Feedback</h4>
        </div>
        <div v-if="!getFeedback.dofeedback">
          <v-textarea
            class="rounded-lg pb-2"
            v-model="dataTextArea"
            flat
            solo
            label="kirim pendapat anda tentang kegiatan ini"
            hide-details="auto"
          ></v-textarea>
          <v-btn
            color="btnPrimary"
            @click="sendFdb()"
            block
            class="py-6 mt-0 white--text mb-10"
          >
            Send
          </v-btn>
        </div>

        <v-alert dense text type="success" class="body-2" v-else
          >Terima kasih, anda sudah memberikan masukan kepada kami</v-alert
        >
        <!-- <v-btn color="primary" class="px-10" outlined @click="govote()">
          Vote Best Employee
        </v-btn> -->
      </v-col>
    </div>

    <!-- dialog  -->
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title class="d-block">
          <span>Hasil Survey</span>
          <v-divider></v-divider>
          <div v-for="(slide, i) in sliders" :key="i">
            <div class="d-block pa-0 body-1 black--text text-left">
              point {{ i + 1 }} : <strong> {{ slide[i] }}</strong>
            </div>
          </div>
          <p class="body-2 font-weight-bold pt-10 text-left"></p>
        </v-card-title>
        <v-card-actions class="d-block text-center">
          <v-btn color="primary" class="px-10" outlined @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snackbar
      :active="activeSnackbar"
      :text="pesan"
      @hideSnackbar="hideSnackbar"
    />
  </div>
</template>

<script>
import Vue from "vue";
import Snackbar from "../../components/Snackbar.vue";

export default {
  components: {
    Snackbar,
  },
  data: () => ({
    //snackbar
    activeSnackbar: false,
    pesan: "Data is require",

    active: true,
    // surveys: null,
    panelsAcc: null,
    dialog: false,
    satisfactionEmojis: [
      "😭",
      "😢",
      "☹️",
      "🙁",
      "😐",
      "🙂",
      "😊",
      "😁",
      "😄",
      "😍",
    ],
    sliders: null,
    dataTextArea: "",
    buttonDisabled1: true,
    buttonDisabled2: true,
    surveys: [
      {
        title:
          "Apakah Anda mendapatkan informasi yang jelas mengenai pencapaian perusahaan pada tahun kerja yang lalu?  ",
      },
      {
        title:
          "Apakah Anda mendapatkan informasi yang jelas mengenai target perusahaan pada tahun kerja ini? ",
      },
      {
        title:
          "Apakah Anda merasa bersemangat dan ingin lebih giat / berinovasi dalam bekerja untuk mencapai target individu maupun tim pada tahun kerja ini?",
      },
      { title: "Apakah ada hal baru yang Anda ketahui dari rekan kerja Anda?" },
      { title: "Apakah Anda puas dengan venue kegiatan kali ini? " },
      { title: "Apakah Anda puas dengan konsumsi kegiatan kali ini? " },
      { title: "Apakah Anda puas dengan rangkaian acara kegiatan kali ini? " },
      {
        title:
          "Apakah Anda puas dengan implementasi IT pada kegiatan kali ini?",
      },
    ],
    errValue: 0,
  }),

  mounted() {
    this.getQuest();
    console.log(this.$store.getters.userFeedback, "<< CHECK FEED");
  },

  beforeMount() {
    this.fetchStatus();
  },
  computed: {
    getInfo() {
      return this.$store.getters.userInfo;
    },
    getFeedback() {
      return this.$store.getters.userFeedback;
    },
  },

  methods: {
    getQuest() {
      this.axios
        .get(`${process.env.VUE_APP_API}/api/questions`)
        .then((response) => {
          const payload = response.data;
          // console.log(payload.data);
          this.surveys = payload.data;
          // console.log(this.surveys.length);
          const xx = [];
          const yy = [];
          for (let i = 0; i < this.surveys.length; i++) {
            xx.push(i);
            yy.push(0);
          }

          this.sliders = yy;
          // console.log(this.sliders);
          this.panelsAcc = xx;
        });
    },
    sendFdb() {
      if (this.dataTextArea.length > 0) {
        this.axios
          .post(`${process.env.VUE_APP_API}/api/feedbacks/post`, {
            sender: this.$store.getters.userInfo.digits,
            userId: this.$store.getters.userInfo.userId,
            id: this.$store.getters.userInfo.userId,
            field: this.dataTextArea,
            // eventTitle: "",
            // eventMeetingLink: "",
          })
          .then((response) => {
            const payload = response.data;
            this.buttonDisabled2 = false;
            this.fetchStatus();
          });
        this.activeSnackbar = false;
      } else {
        this.activeSnackbar = true;
      }
    },
    sendMsg() {
      this.errValue = 0;
      for (let i = 0; i < this.sliders.length; i++) {
        if (this.sliders[i] == 0) {
          this.errValue = 1;
        }
      }
      if (this.errValue > 0) {
        this.activeSnackbar = true;
      } else {
        this.axios
          .post(`${process.env.VUE_APP_API}/api/surveys/post`, {
            userId: this.$store.getters.userInfo.userId,
            id: this.$store.getters.userInfo.userId,
            values: this.sliders,
          })
          .then((response) => {
            const payload = response.data;
            this.sliders = payload.data.values;
            this.fetchStatus();
          });
        this.activeSnackbar = false;
      }
    },
    fetchStatus() {
      this.axios
        .get(
          `${process.env.VUE_APP_API}/api/users/status/` + this.getInfo.digits
        )
        .then((response) => {
          const payload = response.data.data;
          console.log(payload, "<< CHECK DO");
          this.buttonDisabled1 = payload.dosurvey;
          this.$store.commit("SET_STATUS_FB", payload);
        })
        .catch((error) => {
          if (error.response) {
            const payload = error.response.data;
            // const obj = JSON.parse(payload)
            this.pesan = payload.message;
            this.alert = true;
          } else {
            const payload = error.message;
            // const obj = JSON.parse(payload)
            this.pesan = payload;
            this.alert = true;
          }
          // console.log(payload.message);
        });
    },
    hideSnackbar() {
      this.activeSnackbar = false;
    },
    // govote() {
    //   this.$router.push("/user/performance");
    // },

    kirimData() {
      var err = 0;
      const data = {};
      for (let i = 0; i < this.surveys.length; i++) {
        if (this.sliders[i][i] != 0) {
          Vue.set(data, "surv" + i, this.sliders[i][i]);
        } else {
          err++;
        }
      }
      if (this.dataTextArea != "") {
        Vue.set(data, "feedback", this.dataTextArea);
      } else {
        err++;
      }

      if (err < 1) {
        this.dialog = true;
        this.active = false;
        this.buttonDisabled = false;
        this.activeSnackbar = false;
      } else {
        this.activeSnackbar = true;
      }
    },
  },
};
</script>

<style scoped>
.v-input .v-label {
  color: aqua !important;
}
</style>
